import { useLayoutEffect, useRef, useState } from "react"
import Loading from "../loading/loading"

import statusStyle from "./status.module.css"
import managerStyle from "manager/manager.module.css"

import { useOffcanvas } from "offcanvas/provider"
import Axios from "axios"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import { get_grade_list } from "consumer/@@@/get_grade_list"


const today = new Date()
today.setHours(0, 0, 0, 0)
const todayYear = today.getFullYear()
const todayMonth = today.getMonth()
const todayDate = today.getDate()
const todayWeek = today.getDay()


export default function Status() {

    const { offcanvas_open, offcanvas_close } = useOffcanvas()

    const branchInfo = window.EventManager.branchInfo

    const [gradeList, Set_gradeList] = useState([])

    const [searchDay, Set_searchDay] = useState('')
    const [searchWord, Set_searchWord] = useState('')
    const [statusList, Set_statusList] = useState([])
    const [pageSetup, Set_pageSetup] = useState({
        'page': 1,
        'limit': 20,
        'sort': '',
        'sort_option': ''
    })

    const [listLoading, Set_listLoading] = useState(true)

    const isMounted = useRef(0)

    window.EventManager['gradeList'] = gradeList

    useLayoutEffect(() => {
        if(isMounted.current === 0) {
            get_grade_list({
                Set_gradeList: Set_gradeList,
                isMounted: isMounted
            })
        }

        return() => {
            offcanvas_close()
        }
    }, [])

    useLayoutEffect(() => {
        if(isMounted.current === 1) {
            let day = `${todayYear}-${String(todayMonth + 1).padStart(2, '0')}`
            if(searchDay === '') {
                Set_searchDay(day)
            }
            else {
                day = searchDay
            }

            get_status_list(day)
        }
    }, [gradeList, pageSetup])

    async function get_status_list(day) {
        Set_listLoading(true)

        const result = await Axios
                        .post("/omega/status", {
                            search_day: day,
                            search_word: searchWord,
                            page_setup: pageSetup
                        })
        const data = result['data']
        if(data['status'] === 'fail') {
            alert(data['message'])
        }
        else if(data['status'] === 'success') {
            Set_statusList(data['data'])

            Set_listLoading(false)
        }
    }

    function sms() {
        const status = document.getElementById('status')
        const student = status.querySelectorAll('[name="student_one"]:checked')

        if(student.length === 0) {
            alert('신청자를 선택해 주세요.')
        }
        else {
            const receive_phone_list = []
            for(let i=0; i<student.length; i++) {
                receive_phone_list.push({
                    text: student[i].getAttribute('text'),
                    value: student[i].getAttribute('receive'),
                    phone: student[i].getAttribute('phone')
                })
            }

            const form = document.createElement('form')
            form.method = 'post'
            form.action = 'https://damo3.com/c/api/sms-send'
            form.target = 'blank'

            const aaa = document.createElement("input")
            aaa.type = "hidden"
            aaa.name = "receive_phone_list"
            aaa.value = JSON.stringify(receive_phone_list)
            form.append(aaa)

            const bbb = document.createElement("input")
            bbb.type = "hidden"
            bbb.name = "sms_phone"
            bbb.value = branchInfo['smsphone']
            form.append(bbb)

            document.body.append(form)

            form.submit()

            form.remove()
        }
    }

    function checkbox(props) {
        const set = props['set']
        const name = props['name']
        const checked = props['checked']

        const list = []
        if(set === 'all') {
            list.push(...document.getElementsByName(`${name}_one`))
        }
        else if(set === 'one') {
            if(checked) {
                const not_checked = document.querySelector(`[name="${name}_one"]:not(:checked)`)
                if(not_checked === null) {
                    list.push(...document.getElementsByName(`${name}_all`))
                }
            }
            else {
                list.push(...document.getElementsByName(`${name}_all`))
            }
        }

        for(let i=0; i<list.length; i++) {
            list[i].checked = checked
        }
    }

    function sorting(props) {
        const set = props['set']

        Set_pageSetup((preState) => {
            const sort = preState['sort']
            const sort_option = preState['sort_option']
            if(sort_option === '' || sort_option === 'DESC') {
                preState['sort_option'] = 'ASC'
            }
            else {
                preState['sort_option'] = 'DESC'
            }

            if(set !== sort) {
                preState['sort_option'] = 'ASC'
            }

            preState['sort'] = set

            return {...preState}
        })
    }

    async function excel(props) {
        const excel_year = document.getElementsByName('excel_year')[0].value
        const excel_month = document.getElementsByName('excel_month')[0].value
        const result = await Axios
                        .post("/omega/status/excel", {
                            year: excel_year,
                            month: excel_month
                        })
        const data = result['data']
        if(data['status'] === 'fail') {
            alert(data['message'])
        }
        else if(data['status'] === 'success') {
            const list = data['data']

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('1')
            worksheet.columns = [
                {
                    header: '학원',
                    width: 30
                },
                {
                    header: '행사',
                    width: 30
                },
                {
                    header: '제목',
                    width: 30
                },
                {
                    header: '이름',
                    width: 15
                },
                {
                    header: '연락처',
                    width: 30
                },
                {
                    header: '성별',
                    width: 10
                },
                {
                    header: '학년',
                    width: 10
                },
                {
                    header: '재원/희망',
                    width: 10
                },
                {
                    header: '가격',
                    width: 30
                },
                {
                    header: '결제',
                    width: 10
                },
                {
                    header: '프로모션',
                    width: 10
                },
                {
                    header: '예약일',
                    width: 30
                },
                {
                    header: '상태',
                    width: 10
                }
            ]

            for(let i=0; i<list.length; i++) {
                const branch_name = list[i]['Schedule']['branchName']
                const event_name = list[i]['Schedule']['Event']['name']
                const schedule_name = list[i]['Schedule']['title']
                const student_name = list[i]['studentName']
                const parent_phone = list[i]['parentPhone']
                const student_sex = list[i]['studentGender']
                const student_grade = list[i]['studentGrade']
                const grade = gradeList.find(x => x['Mcode'].trim() === student_grade)
                let state_code = list[i]['StateCode']
                if(state_code === '0101') {
                    state_code = '재원'
                }
                else if(state_code === '0104') {
                    state_code = '희망'
                }
                const payment = list[i]['Schedule']['payment']
                let paid = list[i]['paid']
                if(paid) {
                    paid = '●'
                }
                else {
                    paid = ''
                }
                let promotion = list[i]['promotion']
                if(promotion) {
                    promotion = '●'
                }
                else {
                    promotion = ''
                }
                const target_date = list[i]['Schedule']['targetDate']
                const target_time = list[i]['Schedule']['targetTime']
                let status = list[i]['status']
                if(status === 1) {
                    status = '신청'
                }
                else if(status === 2) {
                    status = '대기'
                }
                else {
                    status = '취소'
                }

                worksheet.insertRow(2 + i, [
                    branch_name,
                    event_name,
                    schedule_name,
                    student_name,
                    parent_phone,
                    student_sex,
                    grade['McodeName'],
                    state_code,
                    payment,
                    paid,
                    promotion,
                    `${target_date} ${target_time}`,
                    status
                ])
            }

            const buffer = await workbook.xlsx.writeBuffer()
            saveAs(new Blob([buffer]), `명단_${excel_year}-${excel_month}.xlsx`)
        }
    }

    return(
        <div
            id="status"
            className={statusStyle['statusWrap']}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5px"
                }}
            >
                <div
                    style={{
                        display: "flex",
                    }}
                >
                    {branchInfo['sms'] &&
                        <button
                            type="button"
                            className={`
                                ${managerStyle['button']}
                                ${managerStyle['primary']}
                            `}
                            style={{
                                width: "max-content",
                                height: "30px",
                                paddingInline: "10px",
                                marginRight: "10px"
                            }}
                            onClick={() => sms()}
                        >SMS보내기</button>
                    }

                    <div
                        style={{
                            display: "flex",
                            marginRight: "10px"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100px",
                                height: "30px",
                                border: "1px solid #dbdade",
                                borderTopLeftRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                boxSizing: "border-box",
                                overflow: "hidden"
                            }}
                        >
                            <select
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    outline: "none",
                                    border: "none",
                                }}
                                name="excel_year"
                                key={todayYear}
                                defaultValue={todayYear}
                            >
                                {function() {
                                    const ddd = new Date()
                                    const current_year = ddd.getFullYear()
                                    const min_year = 2026
                                    const www = []
                                    for(let i=current_year; i>=min_year; i--) {
                                        www.push(<option key={i} value={i}>{i}</option>)
                                    }

                                    return www
                                }()}
                            </select>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "70px",
                                height: "30px",
                                border: "1px solid #dbdade",
                                boxSizing: "border-box",
                                overflow: "hidden"
                            }}
                        >
                            <select
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    outline: "none",
                                    border: "none",
                                }}
                                name="excel_month"
                                key={todayMonth}
                                defaultValue={String(todayMonth + 1).padStart(2, '0')}
                            >
                                {function() {
                                    const www = []
                                    for(let i=1; i<13; i++) {
                                        www.push(<option key={i} value={String(i).padStart(2, '0')}>{i}</option>)
                                    }

                                    return www
                                }()}
                            </select>
                        </div>

                        <button
                            type="button"
                            className={statusStyle['button']}
                            style={{
                                width: "70px",
                                height: "30px",
                            }}
                            onClick={() => excel()}
                        >엑셀 다운</button>
                    </div>

                    <div
                        className={statusStyle['input_date']}
                        style={{
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px"
                        }}
                    >
                        <input
                            type="month"
                            min="2026-01"
                            value={searchDay}
                            onInput={(e) => Set_searchDay(e.currentTarget.value)}
                        ></input>
                    </div>

                    <div
                        className={statusStyle['input_text']}
                        style={{
                            width: "200px",
                            borderLeft: "0px",
                            borderRight: "0px",
                            borderRadius: "0px"
                        }}
                    >
                        <input
                            type="text"
                            value={searchWord}
                            placeholder="이름 또는 연락처"
                            onInput={(e) => Set_searchWord(e.currentTarget.value)}
                        ></input>
                    </div>

                    <button
                        type="button"
                        className={statusStyle['button']}
                        style={{
                            width: "70px",
                            height: "30px"
                        }}
                        onClick={() => {
                            Set_listLoading(true)

                            pageSetup['page'] = 1

                            get_status_list(searchDay)
                        }}
                    >검색</button>
                </div>
            </div>

            <div
                style={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto",
                    backgroundColor: "white"
                }}
            >
                <Loading
                    loading={listLoading}
                ></Loading>

                <table className={statusStyle['table']}>
                    <thead>
                        <tr>
                            <th style={{width: "3%"}}>
                                <input
                                    type="checkbox"
                                    style={{
                                        width: "18px",
                                        height: "18px"
                                    }}
                                    name="student_all"
                                    onClick={(e) => checkbox({
                                        set: 'all',
                                        name: 'student',
                                        checked: e.currentTarget.checked
                                    })}
                                ></input>
                            </th>
                            <th style={{width: "5%"}}>번호</th>
                            <th
                                style={{width: "10%"}}
                            >학원</th>
                            <th
                                style={{width: "10%"}}
                                onClick={() => sorting({
                                    set: 'event'
                                })}
                            >행사</th>
                            <th
                                style={{width: "10%"}}
                                onClick={() => sorting({
                                    set: 'schedule'
                                })}
                            >제목</th>
                            <th
                                style={{width: "10%"}}
                                onClick={() => sorting({
                                    set: 'name'
                                })}
                            >이름</th>
                            <th style={{width: "10%"}}>연락처</th>
                            <th style={{width: "5%"}}>성별</th>
                            <th
                                style={{width: "5%"}}
                                onClick={() => sorting({
                                    set: 'grade'
                                })}
                            >학년</th>
                            <th style={{width: "5%"}}>재원/희망</th>
                            <th style={{width: "10%"}}>가격</th>
                            <th style={{width: "3%"}}>결제</th>
                            <th style={{width: "5%"}}>프로모션</th>
                            <th style={{width: "5%"}}>부가정보</th>
                            <th style={{width: "10%"}}>예약일</th>
                            <th style={{width: "5%"}}>상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        {statusList.length !== 0 &&
                        statusList['rows']
                        .map((value, index) => {
                            return(
                                <tr
                                    key={index}
                                    onClick={() => offcanvas_open({
                                        set: 'info',
                                        user_id: value['id']
                                    })}
                                >
                                    <td>
                                        <input
                                            type="checkbox"
                                            style={{
                                                width: "18px",
                                                height: "18px"
                                            }}
                                            name="student_one"
                                            value={value['id']}
                                            onClick={(e) => {
                                                e.stopPropagation()

                                                checkbox({
                                                    set: 'one',
                                                    name: 'student',
                                                    checked: e.currentTarget.checked
                                                })
                                            }}
                                            text={`${value['studentName']}(보)`}
                                            receive={value['studentNo'] ? `P${value['studentNo']}` : `${value['studentName']};${value['parentPhone']}`}
                                            phone={value['parentPhone']}
                                        ></input>
                                    </td>
                                    <td>{statusList['count'] - index - (pageSetup['page'] - 1) * pageSetup['limit']}</td>
                                    <td>{value['Schedule']['branchName']}</td>
                                    <td>{value['Schedule']['Event']['name']}</td>
                                    <td>{value['Schedule']['title']}</td>
                                    <td>{value['studentName']}</td>
                                    <td>{value['parentPhone']}</td>
                                    <td>{value['studentGender']}</td>
                                    <td>
                                        {function() {
                                            const grade = gradeList.find(x => x['Mcode'].trim() === value['studentGrade'])
                                            if(grade) {
                                                return grade['McodeName']
                                            }
                                            else {
                                                return ''
                                            }
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            if(value['isEnrolled']) {
                                                const state = value['StateCode']
                                                if(state === '0104') {
                                                    return '희망'
                                                }
                                                else {
                                                    return '재원'
                                                }
                                            }
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            let payment = value['Schedule']['payment']
                                            if(payment === 0) {
                                                payment = '무료'
                                            }
                                            else {
                                                payment = Number(payment).toLocaleString()
                                            }

                                            return payment
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            if(value['paid']) {
                                                return '●'
                                            }
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            if(value['promotion']) {
                                                return '●'
                                            }
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            if(value['hasResponse']) {
                                                return '●'
                                            }
                                        }()}
                                    </td>
                                    <td>{value['Schedule']['targetDate']} {value['Schedule']['targetTime']}</td>
                                    <td>
                                        {function() {
                                            if(value['status'] === 1) {
                                                return '신청'
                                            }
                                            else if(value['status'] === 2) {
                                                return '대기'
                                            }
                                            else {
                                                return '취소'
                                            }
                                        }()}
                                    </td>
                                    {/* <td>
                                        {function() {
                                            return value['createdAt'].replace('T', ' ').substring(0, 16)
                                        }()}
                                    </td> */}
                                </tr>
                            )
                        })}

                        {statusList.length !== 0 &&
                        statusList['count'] === 0 &&
                            <tr>
                                <td
                                    colSpan={16}
                                    style={{
                                        height: "300px"
                                    }}
                                >자료가 없습니다.</td>
                            </tr>
                        }
                    </tbody>
                    <tfoot></tfoot>
                </table>
            </div>

            <div className={statusStyle['paginationWrap']}>
                <div className={statusStyle['pageWrap']}>
                    {statusList.length !== 0 &&
                        Array
                        .from({length: Math.ceil(statusList['count']/pageSetup['limit'])})
                        .map((value, index) => {
                            return(
                                <div
                                    key={index}
                                    className={`
                                        ${statusStyle['page']}
                                        ${pageSetup['page'] === index + 1 ? statusStyle['select'] : null}
                                    `}
                                    onClick={() => {
                                        const value = index + 1
                                        Set_pageSetup((preState) => {
                                            preState['page'] = value
                                            return {...preState}
                                        })
                                    }}
                                >{index + 1}</div>
                            )
                        })
                    }
                </div>

                <div className={statusStyle['limit']}>
                    <select
                        value={pageSetup['limit']}
                        onChange={(e) => {
                            const value = e.currentTarget.value
                            Set_pageSetup((preState) => {
                                preState['limit'] = Number(value)
                                return {...preState}
                            })
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                    </select>
                </div>
            </div>
        </div>
    )
}